import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import type { TopNavKey } from './top-nav';

/**
 * 경로만으로는 모르는 현재 메뉴를 페이지가 머리에 알려주는 통로.
 *
 * 공고 상세(/news/:id)는 공고의 대표 유형이 곧 메뉴다. 그 값은 데이터를 받아야
 * 알 수 있어 라우트가 마운트된 뒤에 넘긴다. 페이지를 떠나면 지운다.
 */
const Ctx = createContext<{ value: TopNavKey | null; set: (v: TopNavKey | null) => void }>({
  value: null,
  set: () => undefined,
});

export function TopNavActiveProvider({ children }: { children: ReactNode }) {
  const [value, set] = useState<TopNavKey | null>(null);
  return <Ctx.Provider value={{ value, set }}>{children}</Ctx.Provider>;
}

export function useTopNavActive(): TopNavKey | null {
  return useContext(Ctx).value;
}

/** 페이지가 자기 메뉴를 말한다. 떠나면 되돌린다. */
export function useSetTopNavActive(key: TopNavKey | null): void {
  const { set } = useContext(Ctx);
  useEffect(() => {
    set(key);
    return () => set(null);
  }, [key, set]);
}
